/* eslint-disable */
import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import phishing from '../../../../../../assets/education/topic900/section2_1.svg';
import { CTitle } from '../../components/Widget';
import { useUpdateComponentState } from '../../../hooks';
import arrow from '../../../../../../assets/2025/arrow.gif';

interface ISection2Props {
  settings: any;
}

const Section2: React.FunctionComponent<ISection2Props> = ({ settings }) => {
  const ID = '2';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const updateComponentState = useUpdateComponentState();
  const [visibleCount, setVisibleCount] = useState(1); // 默认显示第一条
  const [animationStarted, setAnimationStarted] = useState(false); // 控制动画是否已开始

  React.useEffect(() => {
    // 如果动画还未开始，则不自动播放
    if (!animationStarted) return;

    // 如果已经显示完所有项目，则停止
    if (visibleCount >= paragraphsSettings.risks?.length) return;

    const timer = setTimeout(() => {
      setVisibleCount((v) => v + 1);
    }, 600);

    return () => clearTimeout(timer);
  }, [visibleCount, animationStarted, paragraphsSettings.risks?.length]);

  // 点击箭头图标时触发动画
  const handleArrowClick = () => {
    if (!animationStarted) {
      setAnimationStarted(true);
      // 从第二条开始显示（第一条已经显示）
      setVisibleCount(2);
      updateComponentState(p_course, p_topic, ID, 'education-ocre-section1-1');
    }
  };

  return (
    <div className="topic-section-2">
      <div className="t900_custom">
        <i className="back_piece"></i>
        <CTitle title={paragraphsSettings?.header}></CTitle>
        <div className="content" id="education-ocre-section1-1">
          {!animationStarted && (
            <img className="arrow-img" src={arrow} alt="" />
          )}
          <div className="left-list">
            {paragraphsSettings.risks?.map((r: any, i: number) => (
              <div
                key={i}
                className="risk-item"
                data-show={i < visibleCount}
                onClick={i === 0 ? handleArrowClick : undefined}
                style={{
                  cursor: i === 0 && !animationStarted ? 'pointer' : 'default',
                }}
              >
                <div className="risk-title">{r.title}</div>
                <div className="risk-desc">{r.desc}</div>
              </div>
            ))}
          </div>

          <div className="right-pic">
            <img src={phishing} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section2;
